module.exports = __webpack_public_path__ + "static/media/land.42db0c0e.png";